async function run({ init, $view }) {
	Promise.resolve()
		.then(() => {
			const internalStartTime = performance.now();

			init($view);

			return performance.now() - internalStartTime;
		})
		.then((result) => {
			if (window.debugMode && window.devtools) {
				window.devtools.moduleList.push({
					module: $view ? `${$view[0].attributes["xyl-view"].value}` : "Anonymous",
					loadingTime: result,
					version: "internal",
				});
			}
		});
}

function logModuleEnd(module, startTime) {
	if (window.debugMode && window.devtools) {
		window.devtools.moduleList.push({
			module: module.view,
			loadingTime: performance.now() - startTime,
			version: "new",
		});
	}
}

function runModules(modules) {
	for (const module of modules) {
		let startTime = null;

		if (window.debugMode) {
			startTime = performance.now();
		}

		if (typeof module.view === "undefined") {
			run({ init: module.init, $view: null });

			logModuleEnd(module, startTime);

			continue;
		}

		const $view = document.querySelectorAll(`[xyl-view="${module.view}"]`);

		if ($view.length > 0) {
			if (window.debugMode) {
				startTime = performance.now();
			}

			run({ init: module.init, $view, async: module.async });

			logModuleEnd(module, startTime);
		}
	}
}

export { runModules };
